import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTh, faCheck, faShareAlt, faCamera, faDownload, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { Button, Radio } from '@cmd/library'
import Modal from 'react-modal'
import { Link } from 'react-router-dom'

import ProductItem from '../components/product/Item'
import Accordion from '../components/Accordion'
import Gallery from '../components/Gallery'
import Share from '../components/Share'

import { httpClient } from '../utils/httpClient';
import { rupiah, capitalizeFirstCharacter, moneyToString } from '@cmd/library/lib/utils/function';

import './DetailProduct.css'

const capellaCertified = [
  'Lulus 153 poin Inspeksi',
  'Bebas terendam banjir',
  'Garansi 100 hari',
  'Bebas bongkar mesin',
  'Goresan < diameter 3cm',
  'Bebas kecelakaan',
  'Mekanik bengkel resmi',
  'Pemakaian < 3 tahun',
  'Wax interior & eksterior',
  'Inspeksi bengkel resmi',
  'ODO meter < 60.000km',
  'Lulus spooring & balancing',
  'ODO meter asli',
  'Riwayat service bengkel resmi',
  '100% sparepart ori'
]

const fund = {
  name: 'fund',
  items: [
    {
      id: 'Cash',
      value: 'Cash',
      text: 'Cash'
    },
    {
      id: 'Credit',
      value: 'Credit',
      text: 'Credit'
    }
  ]
}

const customStyles = {
  overlay: {
    backgroundColor: '#fff',
    zIndex: 9999
  },
  content : {
    width: '100%',
    border: 0,
    borderRadius: 0,
    padding: 0,
    overflow: 'visible',
    top : '50%',
    left : '50%',
    right : 'auto',
    bottom : 'auto',
    transform : 'translate(-50%, -50%)'
  }
};

Modal.setAppElement('#root')

const DetailProduct = ({ type }) => {
  const id = window.location.href.split('/').pop();
  const isCar = window.location.href.split('/')[3] == "mobil";
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState({});
  const [price, setPrice] = useState('0');
  const [showInfo, setShowInfo] = useState(false);
  const [interested, setInterested] = useState(false);
  const [infoSubmitted, setInfoSubmitted] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [datum, setDatas] = useState([]);
  const [images, setImages] = useState([]);
  const [payload, setPayload] = useState({
    is_cash: true
  });

  // Calculator state
  const [downPayment, setDownPayment] = useState(30);
  const [tenure, setTenure] = useState(isCar ? 60 : 36);
  const [installment, setInstallment] = useState(0);
  const [dp, setDp] = useState(0);

  const splitThousand = (number) => {
    if (!number && number !== 0) return "";
    return `${number}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  const fetchProduct = async () => {
    const res = await httpClient.get(`/${type}/${id}`)
    setProduct(res.data)
    setPrice(splitThousand(res.data.price))
    setImages(res.data.images)
    setLoading(false)
  }

  const convertThousands = (e) => {

    let value = e.target.value;

    const formatted = (value.split(',').join('')).split('.').join('');
    if (isNaN(formatted)) return;
    const amount = splitThousand(formatted);

    setPrice(amount);
  };

  const setMinimumPrice = (e) => {
    convertThousands(e)
    setPayload({...payload, minimum_amount: parseInt(Number(e.target.value.split('.').join('')))})
  }

  const calculate = async () => {
    const payloadCalc = { dp: downPayment, tenor: tenure };
    const res = await httpClient.post(`/${type}/${id}/calculator`, payloadCalc);

    setDp(res.data.dp)
    setInstallment(res.data.result);
    setPayload({...payload,
      is_car: isCar,
      product_id: id,
      installment: res.data.result
    })
  }

  const setInstallmentString = (amount) => {
    const million = Math.floor(amount/100000)/10;
    if (million > 1) {
      return "Rp " + million + " " + "Jt"
    } else {
      return "Rp " + amount/1000 + " " + "Rb"
    }
  }

  const fetchInventory = async () => {
    const res = await httpClient.get(`/inventory?isCar=${isCar ? 'Mobil' : 'Motor'}&isInternal=false&limit=4&searchQuery=${product && product.City && product.City.name}`)
    setDatas(res.data.rows)
  }

  useEffect(() => {
    fetchProduct()
  }, [])

  useEffect(() => {
    calculate();
  }, [tenure, downPayment])

  useEffect(() => {
    fetchInventory();
  }, [product])

  const handleButtonInfo = (isPriceDown) => {
    setInterested(isPriceDown)
    setShowInfo(true)
  }

  const clearInfo = () => {
    setShowInfo(false)
    setInfoSubmitted(false)
  }

  const handleSubmitSalesInfo = async(e) => {
    e.preventDefault();
    await httpClient.post(`/contact_me`, payload);
    setInfoSubmitted(true);
    window.fbq('track', 'Lead');
  }

  const renderInitialGallery = () => {
    const gallery = []
    for (let i = 0;i < 5;i++) {
      if (i === 0) {
        gallery.push(
          <div className="detail-product-gallery-item detail-product-gallery-item-main" key={`gallery-init-${i}`}>
            <img onClick={() => setIsGalleryOpen(true)} src={images[i]} alt=""/>
          </div>
        )
      } else {
        gallery.push(
          <div className="detail-product-gallery-item" key={`gallery-init-${i}`}>
            <img onClick={() => setIsGalleryOpen(true)} src={images[i]} alt=""/>
          </div>
        )
      }
    }
    return gallery
  }

  if (loading) {
    return (
      <div className="detail-product">
        <section className="loading-section-wrapper">
          <div className="container">
            <div className="row mb--2">
              <div className="col" style={{ textAlign: 'center' }}>
                <b><FontAwesomeIcon icon={faSpinner} spin /> Sedang memuat halaman</b>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }

  return (
    <div className="detail-product">
      <section className="section-wrapper section-product-detail">
        <div className="container">
          <div className="row mb--2">
            <div className="col">
              <div className="detail-product-gallery-wrapper">
                <div className="detail-product-gallery">
                  { images && renderInitialGallery() }
                </div>
                <div className="detail-product-show-gallery">
                  <div>
                    <span className="detail-product-show-gallery-icon">
                      <FontAwesomeIcon icon={faTh} />
                    </span>
                    <span className="text--weight-500" onClick={() => setIsGalleryOpen(true)}>
                      Lihat Semua Foto ({product && product.images && product.images.length})
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <div>
                <div className="detail-product-item detail-product-title">
                  <h1 className="title-big">
                    {`${product && product.year} ${isCar ? product && product.CarType && product.CarType.brand_name : product && product.BikeType && product.BikeType.brand_name}`}
                  </h1>
                  <div className="detail-product-spec-wrapper">
                    <div className="detail-product-spec">
                      <p>
                        SKU: { product && product.sku_number }
                      </p>
                    </div>
                    <div className="detail-product-spec-share">
                      <div className="text--weight-500 text--right">
                        Share
                      </div>
                      <div className="text--size-20">
                        <Share url={window.location.href} title="Capella" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="detail-product-item">
                  <div className="row">
                    <div className="col-6">
                      <div>
                        <div className="detail-product-user">
                          <span className="mr--1 text--size-20">
                            <img src={require('../assets/img/transmision-icon.svg')} alt=""/>
                          </span>
                          <div>
                            <span>Transmisi</span>
                            <p className="text--weight-500">{isCar ? product.CarType && product.CarType.transmission : product.BikeType && product.BikeType.transmission}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div>
                        <div className="detail-product-user">
                          <span className="mr--1 text--size-20">
                            <img src={require('../assets/img/engine-icon.svg')} alt=""/>
                          </span>
                          <div>
                            <span>CC MESIN</span>
                            <p className="text--weight-500">{isCar ? product.CarType && product.CarType.machine_capacity : product && product.BikeType && product.BikeType.capacity}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div>
                        <div className="detail-product-user">
                          <span className="mr--1 text--size-20">
                            <img src={require('../assets/img/legal-icon.svg')} alt=""/>
                          </span>
                          <div>
                            <span>Kondisi Unit</span>
                            <p className="text--weight-500">{product.condition}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div>
                        <div className="detail-product-user">
                          <span className="mr--1 text--size-20">
                            <img src={require('../assets/img/color-icon.svg')} alt=""/>
                          </span>
                          <div>
                            <span>WARNA</span>
                            <p className="text--weight-500">{product.color}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div>
                        <div className="detail-product-user">
                          <span className="mr--1 text--size-20">
                            <img src={require('../assets/img/speedometer-icon.svg')} alt=""/>
                          </span>
                          <div>
                            <span>KILOMETER</span>
                            <p className="text--weight-500">{product && product.mileage}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div>
                        <div className="detail-product-user">
                          <span className="mr--1 text--size-20">
                            <img src={require('../assets/img/location-icon.svg')} alt=""/>
                          </span>
                          <div>
                            <span>LOKASI</span>
                            <p className="text--weight-500">{ product && product.City && product.City.name}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {
                  product && product.condition == 'Capella Certified' && (
                    <div className="detail-product-item">
                      <div className="mb--1 fx justify-content-between align-items-center">
                        <div>
                          <div className="capella-certified-logo">
                            <img src={require('../assets/img/capella-certified.jpg')} alt="" />
                          </div>
                        </div>
                        <div>
                          {
                            product && product.certified_image && (
                              <p className="text--size-14">
                                <a href={product && product.certified_image} target="_blank">
                                  <span className="text--color-gold mr--1"><FontAwesomeIcon icon={faDownload} /></span>
                                  <span className="text--weight-500">Laporan Inspeksi Lengkap</span>
                                </a>
                              </p>
                            )
                          }
                        </div>
                      </div>
                      <div>
                        <div className="row">
                          {capellaCertified.map((item, index) => (
                            <div className="col-6" key={`certified-${index}`}>
                              <div className="detail-product-certified-item">
                                <span>
                                  {item}
                                </span>
                                <span className="detail-product-certified-item-icon">
                                  <FontAwesomeIcon icon={faCheck} />
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )
                }
                {
                  product && product.description && (
                    <div className="detail-product-item">
                      <p>
                        <strong>Deskripsi</strong>
                      </p>
                      <p>
                        {product.description}
                      </p>
                    </div>
                  )
                }
                <div className="detail-product-item">
                  <p>
                    <strong>Spesifikasi dan kelengkapan</strong>
                  </p>
                  <div>
                    {
                      product && product.classification && product.classification.map((classification) => {
                        return (
                          <Accordion title={classification.name} key={classification.name}>
                            {
                                classification.data && classification.data.map((data) => {
                                  return (
                                    <div className="spec-detail-item fx justify-content-between" key={data.name}>
                                      <div>
                                        <p>{data.name}</p>
                                      </div>
                                      <div className="text-align-right">
                                        <p>{data.value}</p>
                                      </div>
                                    </div>
                                  )
                                })
                            }
                          </Accordion>
                        )
                      })
                    }
                  </div>
                </div>
                <div className="detail-product-item">
                  <div className="mb--1">
                    <p><strong>Kalkulator Kredit</strong></p>
                  </div>
                  <div className="mb--2">
                    <p className="text--size-14 mb--1">
                      DP: <span className="text--weight-500">{rupiah(dp)}</span>
                    </p>
                    <div className="detail-product-calculator-button detail-product-calculator-dp">
                      <div className={`detail-product-calculator-dp-button ${downPayment === 15 ? 'active' : ''}`} onClick={() => setDownPayment(15)}>
                        <p className="mb--0 text--center">15%</p>
                      </div>
                      <div className={`detail-product-calculator-dp-button ${downPayment === 20 ? 'active' : ''}`} onClick={() => setDownPayment(20)}>
                        <p className="mb--0 text--center">20%</p>
                      </div>
                      <div className={`detail-product-calculator-dp-button ${downPayment === 25 ? 'active' : ''}`} onClick={() => setDownPayment(25)}>
                        <p className="mb--0 text--center">25%</p>
                      </div>
                      <div className={`detail-product-calculator-dp-button ${downPayment === 30 ? 'active' : ''}`} onClick={() => setDownPayment(30)}>
                        <p className="mb--0 text--center">30%</p>
                      </div>
                    </div>
                  </div>
                  <div className="mb--2">
                    <p className="text--size-14 mb--1">
                      TENOR
                    </p>
                    <div className="detail-product-calculator-button detail-product-calculator-dp">
                      <div className={`detail-product-calculator-dp-button ${tenure === 12 ? 'active' : ''}`} onClick={() => setTenure(12)}>
                        <p className="mb--0 text--center">12 Bulan</p>
                      </div>
                      <div className={`detail-product-calculator-dp-button ${tenure === (isCar ? 24 : 18) ? 'active' : ''}`} onClick={() => setTenure(isCar ? 24 : 18)}>
                        <p className="mb--0 text--center">{isCar ? "24 Bulan" : "18 Bulan"}</p>
                      </div>
                      <div className={`detail-product-calculator-dp-button ${tenure === (isCar ? 36 : 24) ? 'active' : ''}`} onClick={() => setTenure(isCar ? 36 : 24)}>
                        <p className="mb--0 text--center">{isCar ? "36 Bulan" : "24 Bulan"}</p>
                      </div>
                      <div className={`detail-product-calculator-dp-button ${tenure === (isCar ? 48 : 30) ? 'active' : ''}`} onClick={() => setTenure(isCar ? 48 : 30)}>
                        <p className="mb--0 text--center">{isCar ? "48 Bulan" : "30 Bulan"}</p>
                      </div>
                      <div className={`detail-product-calculator-dp-button ${tenure === (isCar ? 60 : 36) ? 'active' : ''}`} onClick={() => setTenure(isCar ? 60 : 36)}>
                        <p className="mb--0 text--center">{isCar ? "60 Bulan" : "36 Bulan"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="mb--1">
                    <p className="text--size-14 mb--1">
                      ESTIMASI CICILAN
                    </p>
                    <div className="detail-product-calculator-button detail-product-calculator-dp">
                      <div className="detail-product-installment">
                        <div className="detail-product-installment-total">
                          <p className="mb--0">
                            {rupiah(installment)}
                          </p>
                        </div>
                        <div className="detail-product-month">
                          <p className="mb--0 text--center">/ bulan</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <span>
                      Kalkulator kredit ini digunakan sebagai dasar perkiraan dan mungkin dapat berbeda sewaktu-waktu berdasarkan tingkat suku bunga yang berlaku
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="detail-product-price">
                <div className="mb--1">
                  <h1 className="title-medium mb--0">Rp {splitThousand(product && product.price)}</h1>
                  <p>
                    Cicilan: {rupiah(installment)} / bulan
                  </p>
                </div>
                <div className="mb--2">
                  <div className="detail-product-benefit">
                    <span className="detail-product-benefit-icon">
                      <FontAwesomeIcon icon={faCheck} />
                    </span>
                    <span>
                      Kredit langsung dari kami
                    </span>
                  </div>
                  <div className="detail-product-benefit">
                    <span className="detail-product-benefit-icon">
                      <FontAwesomeIcon icon={faCheck} />
                    </span>
                    <span>
                      Dapatkan asuransi All Risk untuk pembelian kredit
                    </span>
                  </div>
                  <div className="detail-product-benefit">
                    <span className="detail-product-benefit-icon">
                      <FontAwesomeIcon icon={faCheck} />
                    </span>
                    <span>
                      DP ringan
                    </span>
                  </div>
                  <div className="detail-product-benefit">
                    <span className="detail-product-benefit-icon">
                      <FontAwesomeIcon icon={faCheck} />
                    </span>
                    <span>
                      Dokumen Lengkap
                    </span>
                  </div>
                </div>
                { showInfo ? (
                  infoSubmitted ? (
                    <div>
                      <div className="info-submitted-icon">
                        <span><FontAwesomeIcon icon={faCheck} /></span>
                      </div>
                      <div className="mb--1">
                        <p className="text--center">
                          Terima kasih, tim sales kami akan segera menghubungi Anda
                        </p>
                      </div>
                      <div className="detail-product-price-button mb--1">
                        <Button text="Ok" onClick={() => clearInfo()} />
                      </div>
                    </div>
                  ) : (
                    <div>
                      <form onSubmit = {handleSubmitSalesInfo}>
                        <div className="gallery-filter-item mb--1">
                          <label htmlFor="fund">PENDANAAN</label>
                          <div>
                            <Radio name={fund.name} options={fund.items} value="Cash" onChange={(e) => setPayload({...payload, is_cash: e == "Cash" ? true : false})} />
                          </div>
                        </div>
                        { interested ? (
                          <div className="gallery-filter-item mb--1">
                            <label htmlFor="price">TERTARIK DI HARGA</label>
                            <div className="gallery-filter-distance">
                              <input id="price" name="price" value={price} placeholder="Ketik Harga" onChange={(e) => setMinimumPrice(e)} required/>
                            </div>
                          </div>
                        ) : null }
                        <div className="gallery-filter-item mb--1">
                          <label htmlFor="name">NAMA</label>
                          <div className="gallery-filter-distance">
                            <input type="text" id="name" name="name" placeholder="Ketik Nama" onChange={(e) => setPayload({...payload, name: e.target.value})} required/>
                          </div>
                        </div>
                        <div className="gallery-filter-item mb--1">
                          <label htmlFor="email">EMAIL</label>
                          <div className="gallery-filter-distance">
                            <input type="email" id="email" name="email" placeholder="Ketik Email" onChange={(e) => setPayload({...payload, email: e.target.value})} required/>
                          </div>
                        </div>
                        <div className="gallery-filter-item mb--1">
                          <label htmlFor="phone">NO TELP</label>
                          <div className="gallery-filter-distance">
                            <input type="tel" id="phone" name="phone" placeholder="Ketik No Telp" onChange={(e) => setPayload({...payload, handphone: e.target.value})} required/>
                          </div>
                        </div>
                        <div className="detail-product-price-button mb--1">
                          <Button type="Submit" text="Hubungi saya" />
                        </div>
                      </form>
                      <div className="detail-product-price-button mb--1">
                        <Button text="Kembali" className="btn--accent text--size-18" onClick={() => setShowInfo(false)} />
                      </div>
                    </div>
                  )
                ) : (
                 <>
                  <div className="detail-product-price-button mb--1">
                    <Button text="Saya tertarik, hubungi saya" onClick={() => handleButtonInfo(false)} />
                  </div>
                  <div className="detail-product-price-button mb--1">
                    <Button text="Saya tertarik apabila harga turun" className="btn--accent text--size-18" onClick={() => handleButtonInfo(true)} />
                  </div>
                 </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-wrapper">
        <div className="container">
          <div className="row mb--2">
            <div className="col">
              <div>
                <h1 className="title-medium">
                  Lihat {product && product.BikeType ? "Motor" : "Mobil"} Lainnya
                </h1>
                <p>
                  {capitalizeFirstCharacter(isCar ? "Mobil" : "Motor")} lainnya  di sekitar {product.City.name}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {
              datum && datum.slice(1,4).map( d => {
                return (
                  <div className="col-md-4 col-6 col-sm-6">
                    <div className="mb--1">
                      <Link onClick={() => window.location.replace(`/${isCar ? "mobil" : "motor"}/${d.id}`)}>
                        <ProductItem
                          name={`${d.year} ${isCar ? d.CarType.brand_name : d.BikeType.brand_name}`}
                          image={d.images[0]}
                          detail={{
                            id: d.id,
                            isCar: isCar,
                            year: d.year,
                            type: `${isCar ? `${d.CarType.specification} ${d.CarType.type} ${d.CarType.transmission == 'Manual' ? "MT" : "AT"} ${d.class ? d.class : ""}` : `${d.BikeType.type}`}`,
                            location: d.City.name,
                            price: d.price,
                            condition: d.condition,
                            installment: `${setInstallmentString(d.installment)}/bln`,
                            mileage: `${d.mileage} km`,
                            belowMarketPrice: d.belowMarkret
                          }}
                        />
                      </Link>
                    </div>
                  </div>
                )
              })
            }
            {

            }
          </div>
        </div>
      </section>
      <Modal
        isOpen={isGalleryOpen}
        onRequestClose={() => setIsGalleryOpen(false)}
        style={customStyles}
      >
        <Gallery
          title={`${product && product.year} ${isCar ? product && product.CarType && product.CarType.brand_name : product && product.BikeType && product.BikeType.brand_name}`}
          images={images}
          onClose={() => setIsGalleryOpen(false)}
        />
      </Modal>
    </div>
  )
}

export default DetailProduct
